(function () {
  const normalizedPath = window.location.pathname.replace(/\/+$/, '') || '/';
  const isHome = normalizedPath === '/' || normalizedPath === '/en';
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const isMobileHome = isHome && isMobile;

  function releasePopupScrollLock() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.classList.remove('ReactModal__Body--open');
  }

  function suppressMobileHomePopup(root) {
    const popupRoots = root.querySelectorAll('.react-responsive-modal-root, [role="dialog"].needsclick[class*="kl-private-reset-css"]');
    popupRoots.forEach((popupRoot) => {
      popupRoot.remove();
      releasePopupScrollLock();
    });
  }

  function bootMobileHomeSuppression() {
    suppressMobileHomePopup(document);

    const checks = [250, 800, 1600, 2800, 4500, 7000, 10000];
    checks.forEach((delay) => {
      window.setTimeout(() => {
        suppressMobileHomePopup(document);
      }, delay);
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (
            node.matches &&
            node.matches('.react-responsive-modal-root, [role="dialog"].needsclick[class*="kl-private-reset-css"]')
          ) {
            node.remove();
            releasePopupScrollLock();
            return;
          }
          if (node.querySelectorAll) suppressMobileHomePopup(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }

  if (isMobile) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootMobileHomeSuppression, { once: true });
    } else {
      bootMobileHomeSuppression();
    }
    return;
  }

  if (isHome) return;

  const locale = (document.documentElement.lang || window.shopLocale || '').toLowerCase();
  const localeKey = locale.slice(0, 2);
  const copies = {
    nl: {
      title: '10% korting op je eerste bestelling',
      description: 'Schrijf je in en ontvang direct 10% korting op bamboe toiletpapier.',
      placeholder: 'E-mailadres',
      submit: 'Ja, geef mij 10% korting',
      decline: 'Nee, bedankt',
      footer: 'Geen spam. Alleen relevante updates. Uitschrijven kan altijd.',
    },
    de: {
      title: '10 % Rabatt auf deine erste Bestellung',
      description: 'Melde dich an und erhalte sofort 10 % Rabatt auf Bambus-Toilettenpapier.',
      placeholder: 'E-Mail-Adresse',
      submit: 'Ja, ich möchte 10 % Rabatt',
      decline: 'Nein, danke',
      footer: 'Kein Spam. Nur relevante Updates. Abmeldung jederzeit möglich.',
    },
    fr: {
      title: '10 % de réduction sur votre première commande',
      description: 'Inscrivez-vous et recevez immédiatement 10 % de réduction sur le papier toilette en bambou.',
      placeholder: 'Adresse e-mail',
      submit: 'Oui, je veux 10 % de réduction',
      decline: 'Non, merci',
      footer: 'Pas de spam. Seulement des mises à jour utiles. Désinscription à tout moment.',
    },
    es: {
      title: '10 % de descuento en tu primer pedido',
      description: 'Suscríbete y recibe al instante un 10 % de descuento en papel higiénico de bambú.',
      placeholder: 'Correo electrónico',
      submit: 'Sí, quiero un 10 % de descuento',
      decline: 'No, gracias',
      footer: 'Sin spam. Solo actualizaciones relevantes. Puedes darte de baja cuando quieras.',
    },
  };
  const copy = copies[localeKey];
  if (!copy) return;

  function setText(element, value) {
    if (!element || !value) return;
    element.textContent = value;
  }

  function localizePopup(root) {
    const modal = root.querySelector('.react-responsive-modal-root .ecomsend__Modal__Container');
    if (!modal || modal.dataset.bambooPopupLocalized === 'true') return;

    setText(modal.querySelector('#trustoo-popup-optIn-title'), copy.title);
    setText(modal.querySelector('#trustoo-popup-optIn-description'), copy.description);

    const input = modal.querySelector("input#email");
    if (input) {
      input.placeholder = copy.placeholder;
      input.setAttribute('aria-label', copy.placeholder);
    }

    const submitText =
      modal.querySelector("[id^='ecomsend-submit-button-'] [class*='_text_']") ||
      modal.querySelector("[id^='ecomsend-submit-button-'] [role='button']");
    setText(submitText, copy.submit);

    setText(modal.querySelector(".ecomsend__Modal__CloseText[class*='_closeText_']"), copy.decline);
    setText(modal.querySelector(".ecomsend__Modal__DescriptionText[class*='_descriptionText_']"), copy.footer);

    modal.dataset.bambooPopupLocalized = 'true';
  }

  function run() {
    return Boolean(localizePopup(document));
  }

  function boot() {
    if (run()) return;

    const checks = [500, 1500, 3200, 5200];
    checks.forEach((delay) => {
      window.setTimeout(() => {
        run();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

// Clean Kaching Bundles variable labels that can leak into storefront text.
(function cleanKachingPriceLabels() {
  var pattern = /\bsystem\.(?:original_price|price)\s*/g;
  var scheduled = false;

  function isKachingNode(node) {
    return node && node.nodeType === 1 && (
      node.matches('kaching-bundle, kaching-bundles-block, .kaching-bundles') ||
      node.closest('kaching-bundle, kaching-bundles-block, .kaching-bundles')
    );
  }

  function clean(root) {
    var scope = root && root.nodeType === 1 ? root : document.body;
    if (!scope) return;

    var targets = [];
    if (isKachingNode(scope)) targets.push(scope);
    scope.querySelectorAll && scope.querySelectorAll('kaching-bundle, kaching-bundles-block, .kaching-bundles').forEach(function (el) {
      targets.push(el);
    });

    targets.forEach(function (target) {
      var walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
      var textNode;
      while ((textNode = walker.nextNode())) {
        if (pattern.test(textNode.nodeValue)) {
          textNode.nodeValue = textNode.nodeValue.replace(pattern, '');
        }
        pattern.lastIndex = 0;
      }
    });
  }

  function schedule(root) {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      clean(root || document.body);
    });
  }

  var kachingObserver;
  var discoveryObserver;

  function observeKachingRoot() {
    var root = document.querySelector('.kaching-bundles, kaching-bundle, kaching-bundles-block');
    if (!root || kachingObserver) return Boolean(root);

    schedule(root);
    kachingObserver = new MutationObserver(function () { schedule(root); });
    kachingObserver.observe(root, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { kachingObserver.disconnect(); }, 10000);
    if (discoveryObserver) discoveryObserver.disconnect();
    return true;
  }

  function bootCleanup() {
    if (observeKachingRoot()) return;
    discoveryObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var found = Array.prototype.some.call(mutations[i].addedNodes, function (node) {
          return isKachingNode(node) || (
            node.nodeType === 1 &&
            node.querySelector &&
            node.querySelector('.kaching-bundles, kaching-bundle, kaching-bundles-block')
          );
        });
        if (found && observeKachingRoot()) return;
      }
    });
    discoveryObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { discoveryObserver.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCleanup, { once: true });
  } else {
    bootCleanup();
  }
})();

// Mobile conversion cleanup: compact Shopify consent, suppress Klaviyo modal, clean Kaching a11y labels.
(function bambooMobileConversionCleanup() {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var systemPattern = /\bsystem\.(?:original_price|price)\s*/g;
  var scheduled = false;

  function cleanKachingLabels() {
    document.querySelectorAll('.kaching-bundles [data-a11y-label], .kaching-bundles [aria-label]').forEach(function (el) {
      ['data-a11y-label', 'aria-label'].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (value && systemPattern.test(value)) {
          var next = value.replace(systemPattern, '').trim();
          if (next) el.setAttribute(attr, next);
          else el.removeAttribute(attr);
        }
        systemPattern.lastIndex = 0;
      });
    });
  }

  function compactCookieBanner() {
    var banner = document.querySelector('#shopify-pc__banner.shopify-pc__banner__dialog');
    if (!banner) return;
    banner.style.background = '#ffffff';
    banner.style.border = '1px solid rgba(31, 77, 36, 0.14)';
    banner.style.boxShadow = '0 18px 46px rgba(18, 38, 24, 0.14)';
    banner.style.borderRadius = mobileQuery.matches ? '18px' : '20px';

    if (mobileQuery.matches) {
      banner.style.setProperty('top', 'auto', 'important');
      banner.style.setProperty('left', '8px', 'important');
      banner.style.setProperty('right', '8px', 'important');
      banner.style.setProperty('bottom', '8px', 'important');
      banner.style.setProperty('width', 'auto', 'important');
      banner.style.setProperty('max-width', 'calc(100vw - 16px)', 'important');
      banner.style.setProperty('max-height', '34vh', 'important');
      banner.style.setProperty('overflow', 'auto', 'important');
      banner.style.setProperty('padding', '9px 12px', 'important');
    }
  }

  function suppressMobileKlaviyo() {
    if (!mobileQuery.matches) return;
    document.body && document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"], .klaviyo-form, .klaviyo-close-form, .needsclick[class*="kl-private-reset-css"]').forEach(function (el) {
      var text = (el.innerText || el.textContent || '').toLowerCase();
      var isKlaviyo = /klaviyo|kl-private-reset-css|needsclick/.test(String(el.className));
      var isDiscountPopup = text.indexOf('10% korting') !== -1 || text.indexOf('krijg 10% korting') !== -1 || el.getAttribute('aria-label') === 'POPUP Form';
      if (!isKlaviyo && !isDiscountPopup) return;
      var root = el.closest('[role="dialog"][aria-label="POPUP Form"]') || el.closest('.needsclick[class*="kl-private-reset-css"]') || el;
      root.style.setProperty('display', 'none', 'important');
      root.style.setProperty('visibility', 'hidden', 'important');
      root.style.setProperty('pointer-events', 'none', 'important');
      root.setAttribute('aria-hidden', 'true');
    });
  }

  function run() {
    scheduled = false;
    cleanKachingLabels();
    compactCookieBanner();
    suppressMobileKlaviyo();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  schedule();
  [300, 900, 1800, 3200, 6000].forEach(function (delay) { window.setTimeout(schedule, delay); });

  var cleanupObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (
          node.matches('.shopify-pc__banner__dialog, .kaching-bundles, [role="dialog"][aria-label="POPUP Form"], .klaviyo-form') ||
          node.querySelector('.shopify-pc__banner__dialog, .kaching-bundles, [role="dialog"][aria-label="POPUP Form"], .klaviyo-form')
        ) {
          schedule();
          return;
        }
      }
    }
  });
  cleanupObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () { cleanupObserver.disconnect(); }, 10000);
})();

// Final pass for Kaching labels that are re-applied after async bundle hydration.
(function bambooKachingA11yIntervalCleanup() {
  var pattern = /\bsystem\.(?:original_price|price)\s*/g;
  function clean() {
    document.querySelectorAll('.kaching-bundles [data-a11y-label], .kaching-bundles [aria-label]').forEach(function (el) {
      ['data-a11y-label', 'aria-label'].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (!value || value.indexOf('system.') === -1) return;
        var next = value.replace(pattern, '').trim();
        pattern.lastIndex = 0;
        if (next) el.setAttribute(attr, next);
        else el.removeAttribute(attr);
      });
    });
  }

  clean();
  [400, 1200, 2600, 5000, 8000].forEach(function (delay) {
    window.setTimeout(clean, delay);
  });
})();
